module.exports = __webpack_public_path__ + "img/link-2.50317593.svg";